import React from 'react';
import { PropTypes } from 'prop-types';
import { compose, pure } from 'recompose';
import { Button } from '@ontruck/orc';

const enhance = compose(pure);

const CreateAddress = ({ className, onClick, t }) => (
  <div className={className}>
    <Button
      icon="plus"
      onClick={onClick}
      iconPosition="left"
      text={t('new_address')}
    />
  </div>
);

CreateAddress.propTypes = {
  onClick: PropTypes.func.isRequired,
  t: PropTypes.func,
};

CreateAddress.defaultProps = {
  className: '',
  t: (t) => t,
};

export default enhance(CreateAddress);
